import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {i18nReducer} from 'react-redux-i18n';
import {reducer as formReducer} from 'redux-form';

import {CLEAR_APPLICATION_STATE} from './modules/common/actionTypes';

import caresheets from './modules/caresheets';
import customer from './modules/customer';
import labels from './modules/labels';
import navbar from './modules/navbar';
import search from './modules/search';
import users from './modules/users';

const appReducer = combineReducers({
  [caresheets.constants.NAME]: caresheets.reducer,
  [customer.constants.NAME]: customer.reducer,
  [labels.constants.NAME]: labels.reducer,
  [navbar.constants.NAME]: navbar.reducer,
  [search.constants.NAME]: search.reducer,
  [users.constants.NAME]: users.reducer,
  routing: routerReducer,
  i18n: i18nReducer,
  form: formReducer
});

const rootReducer = (state, action) => {
	if(action.type === CLEAR_APPLICATION_STATE) {
		const {routing, i18n, form} = state;
		state = {routing, i18n, form};
	}
	return appReducer(state, action);
};

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/rootReducer.js
 **/